export class RequestRelatedTreeNode {
	requestId: number;
	requestTypeName: string;
	statusName: string;
	statusColor: string;
	childs: RequestRelatedTreeNode[] = [];
}

export class RequestRelatedTree {
	currentRequestId: number;
	root: RequestRelatedTreeNode;
}
